/**
 * Predictive Search - fetches from Shopify /search/suggest.json and renders results
 */
(function() {
  const DEBOUNCE_MS = 300;
  const MIN_QUERY_LENGTH = 2;
  const QUERY_LIMIT = 6; /* Max to display for suggestions - API returns up to 10 */

  function buildSuggestUrl(query) {
    /* Use only q param - Search & Discovery app settings control types, limits, unavailable products, etc. */
    var params = new URLSearchParams({ 'q': query });
    return (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root.replace(/\/$/, '')
      : window.location.pathname.replace(/\/[^/]*$/, '') || '') + '/search/suggest.json?' + params.toString();
  }

  function formatMoney(cents) {
    if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents);
    }
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function getProductImageUrl(product) {
    var url = '';
    var img = product.featured_image || product.image;
    if (typeof img === 'string') url = img;
    else if (img && img.url) url = img.url;
    else if (product.variants && product.variants[0] && product.variants[0].featured_image && product.variants[0].featured_image.url) {
      url = product.variants[0].featured_image.url;
    }
    if (url && url.indexOf('//') === 0) url = 'https:' + url;
    return url;
  }

  function renderProduct(product) {
    var priceCents = Math.round(parseFloat(product.price) * 100);
    var price = formatMoney(priceCents);
    var comparePrice = null;
    if (product.compare_at_price_min && parseFloat(product.compare_at_price_min) > parseFloat(product.price)) {
      comparePrice = formatMoney(Math.round(parseFloat(product.compare_at_price_min) * 100));
    }
    var imgUrl = getProductImageUrl(product);
    return `
      <a href="${product.url}" class="predictive-search__item predictive-search__item--product">
        <span class="predictive-search__item-image">
          ${imgUrl ? '<img src="' + imgUrl + '" alt="" width="60" height="60" loading="lazy" width="80" height="80" onerror="this.style.display=\'none\';this.parentNode.classList.add(\'predictive-search__item-image--no-img\');">' : ''}
        </span>
        <span class="predictive-search__item-content">
          <span class="predictive-search__item-title">${escapeHtml(product.title)}</span>
          <span class="predictive-search__item-price">
            ${comparePrice ? `<s class="predictive-search__item-compare">${comparePrice}</s> ` : ''}
            <span class="money">${price}</span>
          </span>
        </span>
      </a>
    `;
  }

  function renderQuery(q) {
    return `
      <a href="${q.url}" class="predictive-search__item predictive-search__item--query">
        <span class="predictive-search__item-content">
          ${q.styled_text || escapeHtml(q.text)}
        </span>
      </a>
    `;
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function renderCollection(c) {
    return '<a href="' + (c.url || '#') + '" class="predictive-search__item predictive-search__item--collection">' +
      '<span class="predictive-search__item-content"><span class="predictive-search__item-title">' + escapeHtml(c.title || '') + '</span></span></a>';
  }

  function renderPage(p) {
    return '<a href="' + (p.url || '#') + '" class="predictive-search__item predictive-search__item--page">' +
      '<span class="predictive-search__item-content"><span class="predictive-search__item-title">' + escapeHtml(p.title || '') + '</span></span></a>';
  }

  function renderArticle(a) {
    /* Text-only in left column (Pages section) - matches Dawn */
    return '<a href="' + (a.url || '#') + '" class="predictive-search__item predictive-search__item--article">' +
      '<span class="predictive-search__item-content"><span class="predictive-search__item-title">' + escapeHtml(a.title || '') + '</span></span></a>';
  }

  function renderResults(data) {
    var results = (data.resources && data.resources.results) || {};
    var products = results.products || [];
    var queries = results.queries || [];
    var collections = results.collections || [];
    var pages = results.pages || [];
    var articles = results.articles || [];
    var total = products.length + queries.length + collections.length + pages.length + articles.length;

    if (total === 0) {
      return '<div class="predictive-search__empty">No results found</div>';
    }

    var leftCol = '';
    var rightCol = '';

    /* Left column: Suggestions, Pages (pages + articles), Collections */
    if (queries.length > 0) {
      leftCol += '<div class="predictive-search__group"><div class="predictive-search__group-title">Suggestions</div>';
      queries.slice(0, QUERY_LIMIT).forEach(function(q) { leftCol += renderQuery(q); });
      leftCol += '</div>';
    }
    if (pages.length > 0 || articles.length > 0) {
      leftCol += '<div class="predictive-search__group"><div class="predictive-search__group-title">Pages</div>';
      pages.forEach(function(p) { leftCol += renderPage(p); });
      articles.forEach(function(a) { leftCol += renderArticle(a); });
      leftCol += '</div>';
    }
    if (collections.length > 0) {
      leftCol += '<div class="predictive-search__group"><div class="predictive-search__group-title">Collections</div>';
      collections.forEach(function(c) { leftCol += renderCollection(c); });
      leftCol += '</div>';
    }

    /* Right column: Products */
    if (products.length > 0) {
      rightCol += '<div class="predictive-search__group"><div class="predictive-search__group-title">Products</div>';
      products.slice(0, 4).forEach(function(p) { rightCol += renderProduct(p); });
      rightCol += '</div>';
    }

    var html = '<div class="predictive-search__results predictive-search__results--two-col">';
    if (leftCol) html += '<div class="predictive-search__column predictive-search__column--left">' + leftCol + '</div>';
    if (rightCol) html += '<div class="predictive-search__column predictive-search__column--right">' + rightCol + '</div>';
    html += '</div>';

    return html;
  }

  function showViewAll(query) {
    return '<a href="/search?q=' + encodeURIComponent(query) + '" class="predictive-search__view-all">Search for &quot;' + escapeHtml(query) + '&quot; &rarr;</a>';
  }

  function initPredictiveSearch() {
    const targets = [];

    var drawer = document.getElementById('SearchDrawer');
    if (drawer) {
      var input = drawer.querySelector('input[name="q"], input.search-bar__input, input.search__input');
      var container = drawer.querySelector('.predictive-search__container');
      if (input && container) targets.push({ input: input, container: container, parent: drawer });
    }

    document.querySelectorAll('.search-header__wrapper').forEach(function(wrapper) {
      var input = wrapper.querySelector('input[name="q"]');
      var container = wrapper.querySelector('.predictive-search__container');
      if (input && container) targets.push({ input: input, container: container, parent: wrapper });
    });

    if (targets.length === 0) return;

    var debounceTimer;
    var lastQuery = '';
    var activeTarget = null;

    function hideResults() {
      targets.forEach(function(t) {
        t.container.innerHTML = '';
        t.container.classList.remove('is-visible');
      });
    }

    function setupTarget(t) {
      var input = t.input;
      var container = t.container;
      var parent = t.parent;

      function showResults(html, query) {
        container.innerHTML = html + showViewAll(query);
        container.classList.add('is-visible');
      }

      function fetchResults(query) {
        if (!query || query.length < MIN_QUERY_LENGTH) {
          container.innerHTML = '';
          container.classList.remove('is-visible');
          return;
        }
        query = query.trim();
        lastQuery = query;
        activeTarget = t;

        container.classList.add('is-loading');
        container.innerHTML = '<div class="predictive-search__loading">Searching...</div>';
        container.classList.add('is-visible');

        fetch(buildSuggestUrl(query))
          .then(function(res) { return res.json(); })
          .then(function(data) {
            if (query !== lastQuery || activeTarget !== t) return;
            container.classList.remove('is-loading');
            showResults(renderResults(data), query);
          })
          .catch(function() {
            if (query !== lastQuery || activeTarget !== t) return;
            container.classList.remove('is-loading');
            container.innerHTML = '<div class="predictive-search__empty">Search unavailable</div>';
            container.classList.add('is-visible');
          });
      }

      input.addEventListener('input', function() {
        var query = this.value;
        clearTimeout(debounceTimer);
        if (query.length < MIN_QUERY_LENGTH) {
          container.innerHTML = '';
          container.classList.remove('is-visible');
          return;
        }
        debounceTimer = setTimeout(function() { fetchResults(query); }, DEBOUNCE_MS);
      });

      input.addEventListener('focus', function() {
        if (this.value.length >= MIN_QUERY_LENGTH) {
          fetchResults(this.value);
        }
      });

      input.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          container.innerHTML = '';
          container.classList.remove('is-visible');
        }
      });
    }

    targets.forEach(setupTarget);

    document.addEventListener('click', function(e) {
      var inAny = targets.some(function(t) { return t.parent.contains(e.target); });
      var onToggle = e.target.closest('.site-header__search-toggle');
      if (!inAny && !onToggle) hideResults();
    });

    var closeBtn = document.querySelector('#SearchDrawer .js-drawer-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', hideResults);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPredictiveSearch);
  } else {
    initPredictiveSearch();
  }
})();
